import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {createOrganization} from '../../api/api';

const AddOrganization = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        contactEmail: '',
        contactPhone: '',
        address: { street: '', city: '', state: '', zip: '', country: '' },
        industry: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            address: { ...prev.address, [name]: value },
        }));
    };

    const handleSubmit = async () => {
        try {
            await createOrganization( formData);
            alert('Organization created successfully!');
            navigate('/organizations');
        } catch (error) {
            alert('Error creating organization!');
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" p={3}>
            <Typography variant="h5" mb={2}>
                Add Organization
            </Typography>
            <TextField label="Name" name="name" fullWidth margin="normal" onChange={handleChange} />
            <TextField label="Description" name="description" fullWidth margin="normal" onChange={handleChange} />
            <TextField label="Contact Email" name="contactEmail" fullWidth margin="normal" onChange={handleChange} />
            <TextField label="Contact Phone" name="contactPhone" fullWidth margin="normal" onChange={handleChange} />
            <Typography variant="subtitle1" mt={2} mb={1}>
                Address
            </Typography>
            <TextField label="Street" name="street" fullWidth margin="normal" onChange={handleAddressChange} />
            <TextField label="City" name="city" fullWidth margin="normal" onChange={handleAddressChange} />
            <TextField label="State" name="state" fullWidth margin="normal" onChange={handleAddressChange} />
            <TextField label="ZIP" name="zip" fullWidth margin="normal" onChange={handleAddressChange} />
            <TextField label="Country" name="country" fullWidth margin="normal" onChange={handleAddressChange} />
            <TextField label="Industry" name="industry" fullWidth margin="normal" onChange={handleChange} />
            <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
                <Button variant="contained" color="secondary" onClick={() => navigate('/organizations')}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                    Add Organization
                </Button>
            </Box>
        </Box>
    );
};

export default AddOrganization;
